function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n            transition: transform ",
        "ms ease-in;\n            transform: translateX(",
        "%);\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n            transition: transform 250ms ease-out;\n            transform: translateX(100%);\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    border-radius: ",
        ";\n    width: 100%;\n    right: 100%;\n    transform: translateX(0);\n    background-color: ",
        ";\n    transition: transform 0s linear;\n\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    height: ",
        ";\n    width: 100%;\n    border-radius: ",
        ";\n    overflow: hidden;\n    position: relative;\n    background-color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";
var ProgressBar = function(props) {
    var className = props.className, label = props.label, _autoStart = props.autoStart, autoStart = _autoStart === void 0 ? false : _autoStart, duration = props.duration, _started = props.started, started = _started === void 0 ? false : _started, _completed = props.completed, completed = _completed === void 0 ? false : _completed, _preCompletionMaxPercent = props.preCompletionMaxPercent, preCompletionMaxPercent = _preCompletionMaxPercent === void 0 ? 100 : _preCompletionMaxPercent, _format = props.format, format = _format === void 0 ? "positive" : _format;
    var ref = useState(false), startedInternal = ref[0], setStartedInternal = ref[1];
    useEffect(function() {
        setStartedInternal(started);
        return function() {
            setStartedInternal(false);
        };
    }, [
        started,
        duration
    ]);
    useEffect(function() {
        if (autoStart) {
            var timeout = setTimeout(function() {
                setStartedInternal(true);
            }, 1);
            return function() {
                clearTimeout(timeout);
            };
        }
    }, [
        autoStart,
        duration
    ]);
    return /*#__PURE__*/ _jsxs(ProgressBarStyled, {
        className: className,
        children: [
            label && /*#__PURE__*/ _jsx(LabelStyled, {
                children: label
            }),
            /*#__PURE__*/ _jsx(TrackStyled, {
                format: format,
                children: /*#__PURE__*/ _jsx(ProgressStyled, {
                    duration: duration,
                    started: startedInternal,
                    completed: completed,
                    preCompletionMaxPercent: preCompletionMaxPercent,
                    format: format
                })
            })
        ]
    });
};
var LabelStyled = styled.div.withConfig({
    componentId: "sc-fb629b3b-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.Heading16;
}, rem(13), rem(8));
var ProgressStyled = styled.div.withConfig({
    componentId: "sc-fb629b3b-1"
})(_templateObject3(), rem(3), function(param) {
    var theme = param.theme, format = param.format;
    return format === "positive" ? theme.palette.Green : theme.palette.Red;
}, function(param) {
    var started = param.started, preCompletionMaxPercent = param.preCompletionMaxPercent, duration = param.duration;
    return started && css(_templateObject1(), duration, preCompletionMaxPercent);
}, function(param) {
    var completed = param.completed;
    return completed && css(_templateObject2());
});
var TrackStyled = styled.div.withConfig({
    componentId: "sc-fb629b3b-2"
})(_templateObject4(), rem(4), rem(3), function(param) {
    var theme = param.theme, format = param.format;
    return format === "positive" ? theme.palette.DarkGreen1 : theme.palette.RedTransparent1;
});
var ProgressBarStyled = styled.div.withConfig({
    componentId: "sc-fb629b3b-3"
})(_templateObject5());
export default ProgressBar;
